import React from 'react';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-6 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-black mb-8 tracking-tight">
            {t('contact')}
          </h1>
          <p className="text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto">
            {t('contact_description')}
          </p>
        </div>

        <div className="flex justify-center">
          {/* Contact Information */}
          <div className="max-w-md w-full">
            <h2 className="text-3xl font-bold text-black mb-8 uppercase tracking-wide text-center">
              {t('contact_info')}
            </h2>
            
            <div className="space-y-6">
              {/* Address */}
              <div className="bg-white border-2 border-black p-6">
                <div className="font-bold text-black mb-2 uppercase tracking-wide">
                  {t('address')}
                </div>
                <div className="text-gray-800">
                  Saket Nagar, Lalganj, Raebareli, UP 229206
                </div>
              </div>

              {/* Phone */}
              <div className="text-center bg-black text-white p-6">
                <div className="font-bold mb-2 uppercase tracking-wide">
                  {t('phone')}
                </div>
                <div className="text-gray-200">
                  +91 8090846400
                </div>
                <div className="text-gray-200">
                  +91 8400866400
                </div>
              </div>

              {/* Email */}
              {/* <div className="bg-white border-2 border-black p-6">
                <div className="font-bold text-black mb-2 uppercase tracking-wide">
                  {t('email')}
                </div>
                <div className="text-gray-800">
                  rohit.kumar@kaarigarfoundation.org
                </div>
              </div> */}

              {/* WhatsApp */}
              <a 
                href="https://wa.me/918400866400"
                target="_blank" 
                rel="noopener noreferrer" 
                className="block bg-green-600 text-white p-6 hover:bg-green-700 transition-colors"
              >
                <div className="flex flex-col items-center justify-center">
                  {/* WhatsApp Icon */}
                  <svg className="w-6 h-6 mb-3" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.894 3.488"/>
                  </svg>
                  <div>
                    <div className="font-bold uppercase tracking-wide">
                      {t('contact_whatsapp')}
                    </div>
                    <div className="text-green-100">
                      +91 8090846400
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Additional CTA */}
        <div className="text-center mt-16">
          <div className="bg-black text-white p-8">
            <h3 className="text-2xl font-bold mb-4 uppercase tracking-wide">
              {t('get_involved')}
            </h3>
            <p className="text-gray-300 mb-6">
              {t('get_involved_description')}
            </p>
            <button className="px-8 py-4 border-2 border-white text-white font-bold uppercase tracking-wide hover:bg-white hover:text-black transition-colors">
              {t('learn_more')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;